import * as React from 'react';
export const searchSvg = React.forwardRef(function searchSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M5.1 6.16A3.333 3.333 0 1 1 6.16 5.1l1.62 1.62a.748.748 0 0 1 0 1.06.748.748 0 0 1-1.06 0L5.1 6.16Zm.067-2.827a1.833 1.833 0 1 1-3.667 0 1.833 1.833 0 0 1 3.667 0Z',
    }),
  );
});
searchSvg.defaultProps = {
  width: '8',
  height: '8',
  viewBox: '0 0 8 8',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var search = {
  category: 'icon',
  colorable: true,
  name: 'search',
  svg: searchSvg,
};
